import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { DecorativeDivider } from './ui/DecorativeDivider';
import { HeartIcon, ClockIcon } from 'lucide-react';
export function ObjectionsSection() {
  return <section className="py-10 md:py-16 px-4 md:px-6 bg-navy-light" data-id="element-171">
      <div className="max-w-5xl mx-auto" data-id="element-172">
        <DecorativeDivider data-id="element-173" />

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-8 mt-6 md:mt-12" data-id="element-174">
          <FadeIn direction="up" data-id="element-175">
            <div className="bg-navy-card p-5 md:p-8 rounded-2xl md:rounded-3xl shadow-sm border border-gold/10 h-full" data-id="element-176">
              <div className="w-10 h-10 md:w-12 md:h-12 bg-gold/10 rounded-full flex items-center justify-center mb-4 md:mb-6" data-id="element-177">
                <HeartIcon className="w-5 h-5 md:w-6 md:h-6 text-gold" data-id="element-178" />
              </div>
              <h3 className="text-xl md:text-2xl font-serif font-bold text-white mb-3 md:mb-4" data-id="element-179">
                "No quiero dejarlo llorar"
              </h3>
              <div className="space-y-3 md:space-y-4 text-sm md:text-base text-white/70 leading-relaxed" data-id="element-180">
                <p className="font-medium text-gold" data-id="element-181">Perfecto.</p>
                <p data-id="element-182">
                  El enfoque de esta guía es respetuoso y adaptable. No se trata
                  de "dejar llorar y ya".
                </p>
                <p data-id="element-183">
                  Se trata de acompañar con un plan y reducir dependencias de
                  manera gradual y realista.
                </p>
              </div>
            </div>
          </FadeIn>

          <FadeIn delay={0.2} direction="up" data-id="element-184">
            <div className="bg-navy-card p-5 md:p-8 rounded-2xl md:rounded-3xl shadow-sm border border-gold/10 h-full" data-id="element-185">
              <div className="w-10 h-10 md:w-12 md:h-12 bg-gold/10 rounded-full flex items-center justify-center mb-4 md:mb-6" data-id="element-186">
                <ClockIcon className="w-5 h-5 md:w-6 md:h-6 text-gold" data-id="element-187" />
              </div>
              <h3 className="text-xl md:text-2xl font-serif font-bold text-white mb-3 md:mb-4" data-id="element-188">
                "No tengo tiempo para leer"
              </h3>
              <div className="space-y-3 md:space-y-4 text-sm md:text-base text-white/70 leading-relaxed" data-id="element-189">
                <p data-id="element-190">Está escrito para mamás y papás cansados:</p>
                <ul className="list-disc list-inside space-y-1.5 md:space-y-2 ml-2" data-id="element-191">
                  <li data-id="element-192">claro y directo</li>
                  <li data-id="element-193">fácil de escanear</li>
                  <li data-id="element-194">con resúmenes, checklists y acciones inmediatas</li>
                </ul>
                <p className="font-medium text-gold mt-3 md:mt-4" data-id="element-195">
                  Puedes empezar por el capítulo que más necesitas hoy.
                </p>
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}